import { render, staticRenderFns } from "./sensitivePersonnel.vue?vue&type=template&id=2ddab47b"
import script from "./sensitivePersonnel.vue?vue&type=script&lang=js"
export * from "./sensitivePersonnel.vue?vue&type=script&lang=js"
import style0 from "./sensitivePersonnel.vue?vue&type=style&index=0&id=2ddab47b&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports